// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"6e73ea3e","127":"73f8cbff","283":"1f81e679","410":"fe72bd93","455":"9268a391","482":"084b5c34","507":"d1ff7633","544":"7531f985","708":"4d678648"}[chunkId] + ".chunk.js";
};